import { get } from 'common/utils/object'

function makeTranslate(translations) {
  return (key: string, variables = {}): string => {
    let text = get(key, translations)

    if (typeof text !== 'string') {
      return ''
    }

    const keysToReplace = text.match(/{{\s*[\w.]+\s*}}/g)

    if (keysToReplace) {
      keysToReplace.forEach(key => {
        const rawKey = key.match(/[\w.]+/)[0]
        text = text.replace(key, get(rawKey, variables))
      })
    }

    return text
  }
}

export default makeTranslate
